import React from "react";
import { useParams } from "react-router-dom";
import CreateProductPage from "./CreateProductPage";

/**
 * EditProductPage is a thin wrapper around CreateProductPage that switches
 * the wizard into "edit" mode. It reads the product id from the URL
 * (`/products/:id/edit`) and delegates the entire wizard UI + submit flow
 * to CreateProductPage so that all step components, validation rules and
 * UX details stay consistent with the create flow.
 */
export default function EditProductPage() {
  const { id } = useParams();
  return <CreateProductPage mode="edit" productId={id} />;
}
